import React from 'react';
import { PeriodKey } from '../../../../hooks/useBoardAnalytics';

interface DateRangePillsProps {
  value: PeriodKey;
  onChange: (period: PeriodKey) => void;
}

const PERIODS: { key: PeriodKey; label: string }[] = [
  { key: '7d',       label: '7d'   },
  { key: '30d',      label: '30d'  },
  { key: '90d',      label: '90d'  },
  { key: 'all_time', label: 'All'  },
];

export default function DateRangePills({ value, onChange }: DateRangePillsProps) {
  return (
    <div className="date-range-pills">
      {PERIODS.map((p) => (
        <button
          key={p.key}
          className={`pill-btn${value === p.key ? ' pill-btn--active' : ''}`}
          onClick={() => onChange(p.key)}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
